<script>
  export default {
    data() {
      return {};
    },
    computed: {
      brands() {
        return this.$store.state.brands;
      },
    },
  };
</script>

<template>
  <section id="brands">
    <div class="container">
      <ul class="d-flex flex-lg-nowrap flex-wrap justiy-content-center align-items-center">
        <li
          v-for="(brand, index) in brands"
          :key="index"
          class="d-flex justify-content-center"
          :class="`img-${index}`"
        >
          <img :src="require(`@/assets/images/brands/${brand}`)" alt="" />
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  #brands {
    margin-top: -3.5rem;
    z-index: 99;
    position: relative;
  }

  ul {
    background-color: #fff;
    box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    li {
      width: calc(100% / 8);
      @include media-breakpoint-down(lg) {
        width: 29% !important;
        margin-top: 1rem !important;
        padding: 0;
      }
      @include media-breakpoint-down(sm) {
        width: 45% !important;
        margin-top: 2rem !important;
        img {
        width: auto;
        height: 100% !important;
        max-height: 180px !important;

        
      }
      }
      padding: 10px;
      img {
        width: 100%;
        height: auto ;
        max-height: 180px ;
        filter: grayscale(100%)
      }

      &.img-0 {
        width: 19%;
      }
      &.img-1 {
        width: 18%;
      }
      &.img-2 {
        width: 20%;
      }
      &.img-3 {
        width: 20%;
      }
      &.img-4 {
        margin-left: 1%;
        width: 20%;
      }
      &.img-5 {
        width: 17%;
        margin-left: -2%;
      }
      &.img-6 {
        width: 18%;
      }
      &.img-7 {
        width: 18%;
      }
      &.img-8 {
        width: 24%;
      }
      &.img-9 {
        width: 25%;
        margin-right: 37px;

        @media (max-width:440px){
          margin-right: 0;
        }
      }

    }
  }
</style>
